

































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class KforceHomePage extends Vue {
  mounted() {
    vxm.referrals.fetchPromotereferral();
  }

  get bannerText() {
    return vxm.configs.getHomePageContent('FORUM_IMAGE_PLACE_HOLDER_BANNER_TEXT','BANNER_TEXT')
  }

  get headerText() {
    return vxm.configs.getHomePageContent('FORUM_IMAGE_PLACE_HOLDER_HEADER_TEXT','HEADER_TEXT')
  }

  get footerText() {
    return vxm.configs.getHomePageContent('FORUM_IMAGE_PLACE_HOLDER_FOOTER_TEXT','FOOTER_TEXT')
  }

  get homePageStaticImage() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${
      vxm.jobs.BrandingInfo.companycode
    }/CANDIDATEPORTAL/home_static_image.png`;
  }

  onShareApp() {
    vxm.referrals.setRefferedJob('');
    this.$cookies.remove('referralSuccess');
    this.$cookies.remove('frictionLess');
    this.$router.push({
      name: 'Invite',
    });
  }
}
